import axiosConfig from './axiosApConfig'
// import { server } from './default'

export const saveBehavior = event =>
  axiosConfig.post(`/app/api/passenger/behavior`, event)
